import { render, staticRenderFns } from "./LgFinderPageTipoValor.vue?vue&type=template&id=f3d51de2"
import script from "./LgFinderPageTipoValor.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoValor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports